import { Suspense, useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import AppLoading from '../app-loading/app-loading';
import CEtargetMappingListDataTable from './CEtargetMapping-datatable';
import editUserServices from '../../services/edit-users/edit-users.service';
import ReportPageHeader from '../shared/ReportPageHeader';

const CEtargetMappingList = () => {
    const toast = useRef<Toast>(null);
    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState<any[]>([]);

    const today = new Date();
    const [year, setYear] = useState<number>(today.getFullYear());

    const monthNames = [
        { id: 1, month: "January" },
        { id: 2, month: "February" },
        { id: 3, month: "March" },
        { id: 4, month: "April" },
        { id: 5, month: "May" },
        { id: 6, month: "June" },
        { id: 7, month: "July" },
        { id: 8, month: "August" },
        { id: 9, month: "September" },
        { id: 10, month: "October" },
        { id: 11, month: "November" },
        { id: 12, month: "December" }
    ];
    const [selectedMonth, setSelectedMonth] = useState<any>(monthNames[today.getMonth()]);
    const defaultMonth = monthNames[today.getMonth()];

    useEffect(() => {
        handleSearch();
    }, []);

    const handleSearch = () => {

        if (year && selectedMonth?.id) {
            setLoading(true);
            const filter = { year: year, month: selectedMonth.id };

            editUserServices.getSalesExecutiveTargets(filter)
                .then((response: any[]) => {
                    setDataList(response);
                    setLoading(false);
                })
                .catch(() => {
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to fetch data',
                        life: 3000
                    });
                    setLoading(false);
                });
        } else {
            toast.current?.show({
                severity: 'info',
                summary: 'Info',
                detail: 'Please input the year and month',
                life: 3000
            });
        }
    };

    const handleReset = () => {
        setYear(today.getFullYear());
        setSelectedMonth(defaultMonth);
        setDataList([]);
    };

    return (
        <Suspense fallback={<AppLoading />}>
            <Toast ref={toast} />
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">
                    <ReportPageHeader
                        icon="pi-map"
                        title="Customer Executive Target Mapping"
                        subtitle="View monthly customer executive target assignments and progress"
                        filterLabel="Filter Target Mapping"
                    >
                        <div className="grid">
                            <div className="col-12 sm:col-6 lg:col-4">
                                <InputText
                                    value={year.toString()}
                                    disabled
                                    style={{ width: "100%" }}
                                />
                            </div>
                            <div className="col-12 sm:col-6 lg:col-4">
                                <Dropdown
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.value)}
                                    options={monthNames}
                                    optionLabel="month"
                                    placeholder="Select a Month"
                                    style={{ width: "100%" }}
                                />
                            </div>
                            <div className="col-6 sm:col-3 lg:col-2">
                                <Button className="w-full" onClick={handleSearch} severity="success">
                                    Filter
                                </Button>
                            </div>
                            <div className="col-6 sm:col-3 lg:col-2">
                                <Button className="w-full" onClick={handleReset} text raised>
                                    Reset
                                </Button>
                            </div>
                        </div>
                    </ReportPageHeader>
                </div>
<CEtargetMappingListDataTable 
    data={dataList} 
    year={year} 
    month={selectedMonth.id} 
/>
            </div>
            {loading && <AppLoading />}
        </Suspense>
    );
};

export default CEtargetMappingList;
